module.exports = __webpack_public_path__ + "static/empty-mansions-e08c535622a3dca1857c3fcadf026240.jpg";